import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=9dbb36f2"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=9dbb36f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports